// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout__container[data-v-47782a4f] {\n  padding-left: 5rem;\n  transition: padding-left ease-in-out 0.3s;\n}\n.layout__container--has-menu[data-v-47782a4f] {\n  padding-left: 25rem;\n}\n", ""]);
// Exports
module.exports = exports;
